import ConfirmationModal from "@/v3components/shared/Modal/ConfirmationModal.vue"

/**
 * A composable for showing confirmation modal with configurable properties
 */
const useConfirmation = (modal) => {
  /**
   * Shows a confirmation modal with configurable options
   * @param {Object} config - Configuration for the confirmation modal
   * @param {string} config.heading - The heading text for the modal
   * @param {string} config.headingColor - Color for the heading (e.g., 'red')
   * @param {string} config.headingIcon - Icon class for the heading (e.g., 'ri ri-alert-line')
   * @param {string} config.headerPlacement - How to align the header ('center', 'between', 'start', 'end') (default: 'center')
   * @param {string} config.body - The body text/HTML for the modal
   * @param {string} config.confirmButtonText - Text for the confirm button (default: 'Confirm')
   * @param {string} config.cancelButtonText - Text for the cancel button (default: 'Cancel')
   * @param {boolean} config.confirmButtonSolid - Whether confirm button has solid styling (default: true)
   * @param {boolean} config.cancelButtonSolid - Whether cancel button has solid styling (default: true)
   * @param {boolean} config.showConfirmButton - Whether to show confirm button (default: true)
   * @param {boolean} config.showCancelButton - Whether to show cancel button (default: true)
   * @param {string} config.buttonPlacement - How to align buttons ('center', 'between', 'start', 'end') (default: 'center')
   * @param {string} config.size - Modal size ('sm', 'md', 'lg') (default: 'sm')
   * @param {Object} additionalProps - Additional props to pass to the modal component
   * @returns {Promise<boolean>} - Resolves to true if confirmed, false if canceled
   */
  const showConfirmation = (config = {}, additionalProps = {}) => {
    return new Promise((resolve) => {
      modal.open(ConfirmationModal, {
        placeModalOnCenter: true,
        size: config.size || "sm",
        addOnModalClose: true,
        onModalClose: () => {
          resolve(false)
        },
        props: {
          config,
          onConfirmAction: () => {
            resolve(true)
          },
          onCancelAction: () => {
            resolve(false)
          },
          ...additionalProps
        }
      })
    })
  }

  return {
    showConfirmation
  }
}

export default useConfirmation
